import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.728 2.694a4.457 4.457 0 1 1 6.303 6.303 4.457 4.457 0 0 1-6.303-6.303m3.152.362a2.79 2.79 0 1 0 0 5.58 2.79 2.79 0 0 0 0-5.58m-1.812 10.87a2.79 2.79 0 0 0-2.79 2.79v1.812a.833.833 0 0 1-1.667 0v-1.812a4.457 4.457 0 0 1 4.457-4.457h3.624a4.457 4.457 0 0 1 4.456 4.457v1.812a.833.833 0 0 1-1.666 0v-1.812a2.79 2.79 0 0 0-2.79-2.79z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }